
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
name: "manual-button",
components: {
Checker,
CheckerItem,
},
props:['list','multiple','value','label'],//rules 传入进来的已被选中的规则
data() {

return {
stageList: [
{name: '全部', code: ''},
{name: '新建/立项', code: 'NEW'},
{name: '报名/预审', code: 'ENROLL'},
{name: '报价/投标', code: 'OFFER'},
{name: '评比/评标', code: 'RATING'},
{name: '定价/决标', code: 'AWARD'},
{name: '结束', code: 'FINISH'},
{name: '中止', code: 'SUSPEND'}
],
checkedValue:''
}
},

methods: {
checkChange(e){
this.checkedValue=e;
this.$emit('on-checker-change',e)
}
},
created() {

}


}



// WEBPACK FOOTER //
// ./src/components/manual-button.vue